import { useUser } from "../Use-auth";
import Layout from "../ui/Layout";

export default function RoleBasedLayout({ children }) {
  const { data: user } = useUser();

  if (!user) return null;

  return <Layout>{children}</Layout>;
}
